export const STUDIO_EMAIL = 'hello@norrvik.studio'

export const STUDIO_FACTS = {
    founded: 2009,
    people: 40,
    projects: 38,
    countries: 14,
    points: 318420000,
    carbonAvoided: 412,
    daylightPeak: 78,
    archivePb: 2.3
}

export interface SocialLink {
    label: string
    href: string
}

export const SOCIAL_LINKS: Array<SocialLink> = [
    { label: 'LinkedIn', href: 'https://www.linkedin.com/company/norrvik-architects' },
    { label: 'Instagram', href: 'https://www.instagram.com/norrvik.studio' },
    { label: 'Vimeo', href: 'https://vimeo.com/norrvik' }
]

export interface OpenRole {
    title: string
    office: string
    terms: string
    summary: string
}

export const OPEN_ROLES: Array<OpenRole> = [
    {
        title: 'Survey engineer, reality capture',
        office: 'Stockholm',
        terms: 'Full time',
        summary: 'Plan and run terrestrial and drone surveys, register point clouds and check every structural stage on site.'
    },
    {
        title: 'Building physicist',
        office: 'Lisbon',
        terms: 'Full time',
        summary: 'Build thermal and daylight twins on measured weather and compare them with what the sensors report.'
    },
    {
        title: 'Data engineer, archive systems',
        office: 'Stockholm or Lisbon',
        terms: 'Full time',
        summary: 'Keep 2.3 PB of drawings, scans and decisions indexed, replicated and readable for the next fifty years.'
    }
]

export const PROJECT_TYPES = ['Survey', 'New building', 'Retrofit', 'Monitoring', 'Archive']
